import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';

const pedidoRetiradaUnilateralConfig = {
  id: 'pedido_retirada_unilateral',
  nome: 'Pedido de Retirada Unilateral',
  descricao: 'Solicitação de retirada unilateral de sócio da sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'comunicacaoRetirada', tipoDocumentoProcesso: 491, name: 'Documento - Comunicação de Retirada', description: 'Documento de comunicação de retirada do sócio', required: true }
    ]
  },

  paymentConfig: {
    amount: 104.00
  },

  protocoloConfig: {
    modeloRequerimento: '316',
    tiposAssunto: '834',
    tipoPedido: '506'
  },

  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE,

  tituloConfig: {
    tipoLancamentoId: 156,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection()
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoRetiradaUnilateralConfig;
